import React from 'react';
import { useLanguage } from '../../i18n';
import './tyc.css'

const TyC = () => {
    const { t } = useLanguage();
    const sections = t('tyc.sections');

    return (
        <div className="tyc-container">
            <h1>{t('tyc.title')}</h1>
            <div className="tyc-list">
                {sections.map((section, index) => (
                    <div key={index} className="tyc-item">
                        <h3 style={{ color: '#073C5C' }}>{section.title}</h3>
                        <p>{section.content}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TyC;
